// libraries
import { Box } from '@interstate/components/Box';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';

// components
import IsTargetOutOfPocket from './IsTargetOutOfPocket';

// hooks
import { useCashDownField } from './hooks/useCashDownField';

type CashDownFieldProps = {
    displayLabel?: boolean;
};

export const CashDownField = ({ displayLabel = true }: CashDownFieldProps) => {
    const { label, showTargetOutOfPocket, hasAdjustmentInputError, inputProps } = useCashDownField();

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <NumericInput {...inputProps} label={displayLabel ? label : undefined} displayLabel={displayLabel} />
            {showTargetOutOfPocket && <IsTargetOutOfPocket hasAdjustmentInputError={hasAdjustmentInputError} />}
        </Box>
    );
};

export default CashDownField;
